import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import ApriElementoDiLista from "../../interfaccia/tasti/ApriElementoDiLista"

function ElencoMenu({
    lista,
    apriElemento,
    loading
}) {
    const [rows, setRows] = useState(
        lista
      )
    
      useEffect(() => {
        setRows(lista)
      }, [lista]);
    
      const colonnaApriElemento = function (nomeDato, labelDato, width, idSped, sortField, compact, conditionalCellStyles) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: true,
          ignoreRowClick: true,
          reorder: true,
          compact: compact ? true : false,
          width: width + "px",
          sortField: sortField,
          conditionalCellStyles: conditionalCellStyles,
          cell: (row) => <div className="rowitem"><ApriElementoDiLista id={row[idSped]} testo={row[nomeDato]} apriElemento={apriElemento}/></div>
         
        })
      }

      const colonnaUniversale = function (nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, compact) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: sortable,
          hide: hide,
          reorder: reorder,
          width: width + "px",
          conditionalCellStyles: conditionalCellStyles,
          ignoreRowClick: ignoreRowClick,
          sortField: sortField,
          compact: compact
        })
      }

      const arrayACapo = function (nomeDato, labelDato, width, sortField) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: true,
          ignoreRowClick: true,
          /* sortFunction: caseInsensitiveSort, */
          reorder: true,
          width: width + "px",
          sortField: sortField,
          cell: (row) => {
            if (row[nomeDato] && Array.isArray(row[nomeDato])) {
              if (row[nomeDato][0] && Array.isArray(row[nomeDato][0])) {
                return (
                  <div>
                    {row[nomeDato].map((arr)=> arr.map((dato)=><div>{dato}</div>))}
                  </div>
                )
              } else {
                return (
                  <div>
                    {row[nomeDato].map(dato=><div>{dato}</div>)}
                  </div>
                )
              }          
            }
          }
        })
      }
    
      const columns = [
        colonnaApriElemento('titoloMenu', 'titolo', 300, '_id', false,false),
        /* colonnaUniversale('note', 'Note', 300, true, "sm", true, false, false, null, false), */
        /* arrayACapo("arrFornitori",'Fornitori',200,null),    */     
      ];
      
    
      return (
        <div
          className="h-100"
        >
          <DataTable
            data={rows}
            columns={columns}
            fixedHeader={false}
            fixedHeaderScrollHeight={"100px"}
            striped={false}
            progressPending={loading}
            noDataComponent={<h3 className='ma5 pa5'>Nessun menu risponde alla tua ricerca.</h3>}
            progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
            pagination
            paginationRowsPerPageOptions={[10,50,200]}
            paginationPerPage={10}
            paginationComponentOptions={{ rowsPerPageText: '', rangeSeparatorText: 'di', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Seleziona tutti' }}
          />
          
        </div>
      )
}

export default ElencoMenu;

